<section 
   data-component="popup-site-disclosure-tnc"
   role="dialog"
   [attr.aria-describedby]= "ariaDescribedBy">

   <h1 
    id="{{ariaTitleId}}"
    role="heading"
    aria-level="1"
    [innerHTML]="disclosureTncHeadline"></h1>

  <span class="separator" aria-hidden="true"></span>
  <div class="popup_scrolled_content_border" id="{{ariaBodyId}}">
    <div class="popup_scrolled_content">
       <p [innerHTML]="disclosureTncCopy1"></p>
       <p [innerHTML]="disclosureTncCopy2"></p>
       <p [innerHTML]="disclosureTncCopy3"></p>
       <p [innerHTML]="disclosureTncCopy4"></p>
       <p [innerHTML]="disclosureTncCopy5"></p>
      </div>
  </div>

	<!--close button on top right corner-->
	<section class="close-modal">
		<button
      class="close-modal-icon text-button focus-here"
			[attr.aria-label]="disclosureCloseDialogADA" 
			(click)="close()">
		</button>
	</section>
</section>
